// src/utils/invoicingApi.js
import apiInstance from './apiAuth';
export const invoicingApi = {
  getWorklist: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return apiInstance.get(`company/invoicing-worklist/${q ? `?${q}` : ''}`);
  },
  getInvoices: (companyId) => apiInstance.get(`company-invoices/?company=${companyId}`),
  createInvoice: (payload) => apiInstance.post('company-invoices/', payload),
  updateInvoice: (id, payload) => apiInstance.patch(`company-invoices/${id}/`, payload),
  markInvoiced: (id) => apiInstance.patch(`company-invoices/${id}/`, { status: 'invoiced' }),
  removeInvoice: (id) => apiInstance.delete(`company-invoices/${id}/`),
};
